// src/Calculators/CommonComponents/Header.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';

const Header = ({ toggleSidebar }) => {
  return (
    <nav className="custom-navbar">
      <div className="navbar-container">
        {/* Left: Hamburger + Logo + Links */}
        <div className="navbar-left">
          {/* Hamburger for Sidebar toggle */}
          <button
            className="hamburger-btn"
            onClick={toggleSidebar}
            aria-label="Toggle Sidebar"
          >
            <Menu size={24} />
          </button>

          {/* Logo */}
          <Link className="navbar-logo" to="/">
            <img src="/logo1.png" alt="eLexyt" className="company-logo" />
          </Link>

          {/* Desktop Links */}
          <ul className="navbar-links">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#">About Us</Link>
            </li>
          </ul>
        </div>

        {/* Right: Login/Signup */}
        <div className="navbar-right">
          <Link to="/login" className="btn-login">Log In</Link>
          <Link to="/login" className="btn-signup">Sign Up</Link>
        </div>
      </div>
    </nav>
  );
};

export default Header;